import React, { useState } from "react";
import { Grid, Col, Row } from "react-flexbox-grid";
import { Image, Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import { privacyRequest } from "./footer_logic";

const Footer = props => {
  const layout = JSON.parse(Cookies.get("layout_02"));
  const [privacyModalElements, setPrivacyModalElements] = useState({});
  const [showModal, setShowModal] = useState(false);

  const getDataPrivacy = async () => {
    await privacyRequest( setPrivacyModalElements, setShowModal );
  };

  return (
    <>
      <footer>
        <Grid className="pY-10" fluid={true} style={{backgroundColor:'#5c5c5c', color:'#fff', fontWeight:'bold'}}>
          <Row center="xs" middle="xs">
            <Col xs={6}>
              <span>
                Consulta nuestro{" "}
                <span 
                  onClick={getDataPrivacy}
                  className="cursor-pointer px-1"
                  style={{color:'#10e9c3', textDecoration:'underline'}}
                >
                  aviso de privacidad
                </span>{" "}
                vigente
              </span>
            </Col>
            <Col xs={6}>
              <img 
                style={{ height:'150px'}}
                src={process.env.PUBLIC_URL + "/img/footer_jalisco_image.png"} 
              />
            </Col>
          </Row>
        </Grid>
      </footer>
      <>
          <Modal
            size="lg"
            show={showModal}
            onHide={() => setShowModal(false)}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            {privacyModalElements}
          </Modal>
        </>
    </>
  );
};

export default Footer;
